<div class="" style="margin-bottom:15px !important">
    <!--latest news-->
    <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
        <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
            <span style="float:left">Connections</span>
        </h6>
    </div>
    <div class="col-xl-12 block-style" style="padding: 20px !important; border-top-right-radius: 0px; border-top-left-radius: 0px">
        <div class="row small-section-content">
            <div (click)="openConnection()" *ngIf="userConnections.length == 0" class="col-xl-12 text-center empty" style="padding: 20px 0 0 0;">
                <i class="fa fa-users" style="font-size: 60px; opacity: .1;"></i>
                <p style="font-size: 16px; margin-top: 20px;">Start networking with your friends</p>
            </div>

            <div *ngFor="let item of userConnections | slice:0:5" (click)="openUserProfile(item.id)" class="col-xl-12 no-padding " style="cursor: pointer;">
                <div class="row userlist" style=" margin: 5px; padding: 10px;">
                    <div class="col-xl-2" style="padding:0px">
                        <div class="postContactLogo default-bg" style="border-radius: 50%; background-size: cover; width: 40px; height: 40px" [ngStyle]="{'background-image': 'url(' + item.contactLogo + ')'}">
                        </div>
                    </div>
                    <div class="col-xl-10">
                        {{item.firstName}} {{item.lastName}} <br />
                        <small style="opacity:.5" class="feed-time-date">
                            <span *ngIf="item.title != ''  ">{{item.title}}</span>
                            <span *ngIf="item.portalAccount.name  != '' && item.title  != ''  "> , </span>
                            <span *ngIf="item.portalAccount.name  != ''  ">{{item.portalAccount.name}}</span>
                        </small>
                    </div>
                </div>
            </div>


            <div *ngIf="userConnections.length != 0" class="col-xl-12 text-center" style="margin-top:20px">
                <button style="height:40px" (click)="openConnection()" class="btn btn mygistec-btn-outline">more connections</button>
            </div>
        </div>
    </div>

</div>

